<template>
  <div class="helpCenter">
    <CommonTitle titleName="帮助中心" />
    <div class="title">
      <p>常见问题</p>
    </div>
    <template v-for="item in problemTree">
      <ExpandableOption :singleOption="item" :key="item.categoryId" />
    </template>
    <div class="footerBox" @click="handleOpenAdvisory">
      <p>未解决，联系人工客服</p>
    </div>
    <ChatType v-if="chatTypeShow" @closeAdvisory="handleCloseAdvisory" />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { getHelpCategoryList } from '@/api/personal/helpCenter/index';
import ExpandableOption from './components/ExpandableOption.vue';
import ChatType from '../../arkHome/components/chatType.vue';

export default {
  data() {
    return {
      problemTree: [],
      chatTypeShow: false,
    };
  },
  components: {
    CommonTitle,
    ExpandableOption,
    ChatType,
  },

  created() {
    this.getCategoryList();
  },

  methods: {
    async getCategoryList() {
      const result = await getHelpCategoryList(); // category接口
      if (result && result.data) {
        if (result.data.data.length > 0) {
          this.problemTree = result.data.data;
        } else {
          console.log('暂无帮助');
        }
      }
    },

    handleOpenAdvisory() {
      this.chatTypeShow = true;
    },

    handleCloseAdvisory() {
      this.chatTypeShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.helpCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-top: 100px;
  padding: 20px 32px 0;
  background-color: #fff;

  .title {
    width: 100%;
    margin-bottom: 30px;
    text-align: left;
  }

  .title > p {
    color: #333;
    font-weight: bold;
    font-size: 33px;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  }

  .footerBox {
    position: fixed;
    bottom: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 634px;
    height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }

  .footerBox > p {
    color: #fff;
    font-weight: 500;
    font-size: 33px;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    line-height: 45px;
  }
}
</style>
